import React, { useQuery } from '@apollo/react-hooks';
import { FC } from 'react';
import { GET_CHANNEL_AND_SUBSCRIPTION } from '../../../gql/channels';
import ChannelCover from './ChannelCover';

interface ChannelCoverFetchDataProps {
	channelId: string;
}
export const ChannelCoverFetchData: FC<ChannelCoverFetchDataProps> = ({ channelId }) => {
	const { data } = useQuery(GET_CHANNEL_AND_SUBSCRIPTION, {
		variables: { id: channelId },
		fetchPolicy: 'network-only'
	});

	if (!data) return <></>;

	return (
		<ChannelCover
			channel={data.channel}
		/>
	);
}
